import { API_URL_MAIN } from '@/config';
import { axios } from '@/lib/axios';

export type I_RegistEmailInfo = {
  email_id: string;
  login_id: string;
  password: string;
};

export const registEmail = (data: I_RegistEmailInfo): Promise<I_RegistEmailInfo> => {
  return axios.post(`${API_URL_MAIN}/register_email`, data);
};
